import { Badge } from '@/components/ui/badge';
import type { QCStatus } from '../../types';

interface QCStatusBadgeProps {
  status?: QCStatus;
}

const statusConfig: Record<QCStatus, { label: string; variant: 'default' | 'secondary' | 'outline' | 'destructive' }> = {
  not_required: { label: 'No QC', variant: 'outline' },
  pending: { label: 'QC Pending', variant: 'secondary' },
  passed: { label: 'QC Passed', variant: 'default' },
  failed: { label: 'QC Failed', variant: 'destructive' },
};

export function QCStatusBadge({ status }: QCStatusBadgeProps) {
  if (!status || status === 'not_required') return null;

  const config = statusConfig[status] || { label: status, variant: 'secondary' as const };

  const colorClasses: Record<QCStatus, string> = {
    not_required: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
    pending: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
    passed: 'bg-green-100 text-green-800 hover:bg-green-100',
    failed: 'bg-red-100 text-red-800 hover:bg-red-100',
  };

  return (
    <Badge
      variant={config.variant}
      className={colorClasses[status]}
    >
      {config.label}
    </Badge>
  );
}
